import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import HomePage from '@/pages/Home';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path={ROUTE_PATHS.HOME} element={<HomePage />} />
      </Routes>
    </Router>
  );
}
